// `PlatformDataAdapter` — the package's ENTIRE data surface.
//
// Components never fetch on their own; the consumer supplies an
// adapter through `<PlatformProvider adapter={…}>` (the TanStack /
// react-aria headless pattern). The console implements it over its
// tRPC vanilla client + `bffEndpoints()`-based EventSource; a future
// direct-CP adapter (sdk-ts + Cognito bearer) must fit the same
// interface — so nothing here assumes cookies vs bearer, base URLs,
// or any specific transport.
//
// **Boundary rule (fn-47 R2):** this package owns its browser-safe
// view-model types and imports NOTHING from `@sb-ai-platform/bff`,
// `@sb-ai-platform/control-plane`, tRPC, or sdk-ts. The browser
// transport (e.g. the `EventSource` SSE primitive) lives in the
// CONSUMER's adapter; the package only consumes the callback contract
// of `connectSessionStream`. Field names stay snake_case where they
// mirror the control-plane wire shape (`sessions` / `approvals_audit`
// columns) so consumer adapters are pass-throughs, not mappers.
/**
 * Typed rejection for `decideApproval`. The ADAPTER owns the mapping
 * from its transport errors (tRPC codes, HTTP statuses, fetch
 * failures) to a `DecisionError` — components only ever branch on
 * `kind`. A non-`DecisionError` rejection is treated as `other`.
 */
export class DecisionError extends Error {
    kind;
    constructor(kind, message, options) {
        super(message, options);
        this.name = 'DecisionError';
        this.kind = kind;
    }
}
//# sourceMappingURL=adapter.js.map